<template>
  <div>
    <autoLogout />
    <loader :loader="sending" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)" />
      <v-card v-if="showAction(1)">
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              v-if="$utilFront.withPermission($prm.ADD_STUDY_PROFILE)"
              cols="12"
              md="4"
              xl="3"
              sm="12"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @click="changeAction(2)"
                  >
                    <v-icon left>mdi-plus</v-icon> Nuevo perfil de estudio
                  </v-btn>
                </template>
                <span>Agregar perfil de estudio</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headers"
            :items="list"
            :search="search"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              'items-per-page-all-text': 'Todo',
            }"
            no-results-text="Sin resultados coincidentes con el búsqueda"
            loading-text="Cargando..."
            no-data-text="Sin resultados disponibles"
            dense
            fixed-header
            height="auto"
          >
            <template v-slot:[`item.status`]="{ item }">
              <v-btn
                icon
                @click.native.prevent.stop.capture="editarStatus(item)"
              >
                <v-switch v-model="item.status" color="success"></v-switch>
              </v-btn>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip
                top
                v-if="$utilFront.withPermission($prm.UPDATE_STUDY_PROFILE)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="checkStudyModality(item)">
                    <v-icon color="blue" v-bind="attrs" v-on="on">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </template>
                <span>Editar información</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="$utilFront.withPermission($prm.DELETE_STUDY_PROFILE)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="openDialogDelete(item)">
                    <v-icon color="error" v-bind="attrs" v-on="on">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-row class="py-3" align="center" justify="center">
            <v-col cols="6">
              <v-row align="center" justify="center">
                <v-col class="text-center">
                  <export-import-btn
                    texto="Importar perfiles de estudio"
                    icono="import"
                    color="light-blue darken-2"
                    @accion="askFileImport()"
                  />
                </v-col>
                <v-col class="text-center">
                  <export-import-btn
                    texto="Exportar perfiles de estudio"
                    icono="export"
                    color="green darken-1"
                    @accion="exportStudyModality()"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <encabezado
        :elementos="encabezado"
        v-if="showAction(2) || showAction(3)"
      />
      <v-card v-if="showAction(2) || showAction(3)">
        <validation-observer ref="form" v-slot="{ invalid }">
          <v-form @submit.prevent="doAction">
            <div class="container">
              <v-row>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Nombre de perfil de estudio"
                    rules="required|max:100"
                  >
                    <v-text-field
                      v-model="dataModal.name"
                      :counter="100"
                      :error-messages="errors"
                      label="Nombre de Perfil de estudio"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Modalidad"
                    rules="required"
                  >
                    <v-autocomplete
                      v-if="showAction(2)"
                      v-model="dataModal.modality"
                      label="Modalidad"
                      :items="listModality"
                      :item-text="listModality.text"
                      :item-value="listModality.value"
                      :error-messages="errors"
                      v-on:change="checkSpeciality"
                    >
                    </v-autocomplete>
                    <v-autocomplete
                      v-if="showAction(3)"
                      v-model="dataModal.modality.idModality"
                      label="Modalidad"
                      :items="listModality"
                      :item-text="listModality.text"
                      :item-value="listModality.value"
                      :error-messages="errors"
                      v-on:change="checkSpeciality"
                    >
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Acrónimo de perfil de estudio"
                    rules="required|max:100"
                  >
                    <v-text-field
                      v-model="dataModal.acronym"
                      :counter="100"
                      :error-messages="errors"
                      label="Acrónimo de Perfil de estudio"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <v-switch
                    v-model="switchrequireBiradsReport"
                    label="Reporte de BI-RADS"
                  ></v-switch>
                </v-col>
                <v-col v-if="flagContainer">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Modalidad"
                    rules="required"
                  >
                    <v-autocomplete
                      v-model="dataModal.containerType"
                      label="Tipo de Contenedor"
                      :items="listContainerType"
                      :item-text="listContainerType.text"
                      :item-value="listContainerType.value"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
              </v-row>
            </div>
            <div class="d-flex justify-center">
              <v-col class="d-flex justify-space-around">
                <div v-on:click="changeAction(1)">
                  <btn-accion :elements="btnCancell" />
                </div>
                <v-btn
                  type="submit"
                  :disabled="sending || invalid"
                  color="success"
                >
                  <v-icon left>{{ iconoAdd }}</v-icon>
                  {{ textoAdd }}
                </v-btn>
              </v-col>
            </div>
          </v-form>
        </validation-observer>
      </v-card>
      <v-dialog v-model="dialog" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            {{ dialogs.title }}
          </v-card-title>
          <v-card-text>{{ dialogs.text }} </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false"> Cancelar </v-btn>
            <v-btn
              color="primary"
              text
              @click="
                dialog = false;
                changeStatus();
              "
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="importDialog" max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            Importar perfiles de estudio
          </v-card-title>
          <v-card-text>
            <v-file-input
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv"
              label="Cargar archivo"
              placeholder="Seleccione un archivo"
              v-model="fileXls"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="importDialog = false">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="importStudyModality()"
              :disabled="!fileXls"
            >
              Cargar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="updateModal" max-width="450">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col class="text-center">
                <h1>Perfiles de estudio</h1>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row class="d-flex flex-column" justify="center" align="center">
              <v-col
                class="text-center font-weight-bold title"
                :class="results.done ? 'success--text' : 'error--text'"
              >
                {{
                  results.done
                    ? "Registros cargados correctamente"
                    : "Sucedio un error al cargar los registros"
                }}
              </v-col>
              <v-col>
                <h2 class="font-weight-black">
                  <v-icon color="success" left>mdi-check-circle</v-icon>Nuevos:
                  {{ results.news }}
                </h2>
              </v-col>
              <v-col>
                <h2 class="font-weight-black">
                  <v-icon color="warning" left>mdi-circle-edit-outline</v-icon
                  >Modificados: {{ results.updates }}
                </h2>
              </v-col>
              <v-col>
                <h2 class="font-weight-black">
                  <v-icon color="error" left>mdi-alert-circle</v-icon>Errores:
                  <ul>
                    <li
                      v-for="(error, index) in results.errors"
                      :key="index"
                      class="my-3"
                    >
                      <v-icon color="warning" left>mdi-exclamation</v-icon>Error
                      {{ index + 1 }}: {{ error }}
                    </li>
                  </ul>
                </h2>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-col class="text-center">
              <v-btn text color="error" @click="updateModal = !updateModal"
                >Cerrar</v-btn
              >
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDelete" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            ¿Desea eliminar el perfil de estudio?
          </v-card-title>
          <v-card-text>
            <strong>Perfil de estudio: </strong> {{ model.name }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="closeDialogDelete()">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="deleteStudyModality()"
              :disabled="sending"
            >
              Sí, eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Datatable from "../../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../../components/Sidebar";
import BtnAccion from "../../components/btnAccion.vue";
import {
  StudyModalityRequest,
  ModaltyRequest,
  ReportPDFRequest,
  EnumRequest,
} from "@/core/request";
import { required, max } from "vee-validate/dist/rules";
import AutoLogout from "../../components/AutoLogout.vue";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { mapActions } from "vuex";
import ExportImportBtn from "../../components/ExportImportBtn.vue";
import Loader from "../../components/Loader.vue";
setInteractionMode("eager");
extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("max", {
  ...max,
  message: "{_field_} no debe ser mayor de {length} caracteres",
});

export default {
  name: "Perfiles",
  components: {
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    Datatable,
    BtnAccion,
    AutoLogout,
    ExportImportBtn,
    Loader,
  },
  data() {
    return {
      importDialog: false,
      dialog: false,
      search: "",
      dataModal: {},
      action: 1,
      encabezado: {
        icono: "mdi-format-list-bulleted-type",
        texto: "Perfiles de estudio",
      },
      list: [],
      listModality: [],
      sending: true,
      dialogs: {
        title: "¿Desea cambiar el estatus de éste perfil de estudio?",
        text:
          "El perfil de estudio será habilitada / inhabilitada de inmediato y podría afectar a los registros que dependan de ella",
      },
      headers: [
        { text: "ID Perfil de estudio", value: "idStudyModality" },
        { text: "Nombre", value: "name" },
        { text: "Acrónimo", value: "acronymText" },
        { text: "Modalidad", value: "modality.name" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      btnAdd: {
        icon: "mdi-plus",
        text: "Agregar Perfil de estudio",
        tooltip: "Agregar Perfil de estudio",
      },
      btnCancell: {
        icon: "mdi-close",
        text: "Cancelar registro",
        tooltip: "Cancelar registro",
        color: "error",
      },
      iconoAdd: "mdi-plus",
      textoAdd: "Registrar perfil de estudio",
      service: StudyModalityRequest,
      service: ModaltyRequest,
      results: {},
      updateModal: false,
      sending: false,
      fileXls: null,
      dialogDelete: false,
      model: {},
      listContainerType: [],
      flagContainer: false,
      switchrequireBiradsReport: false,
    };
  },
  created() {},
  mounted() {
    this.validBrowserTab();
    this.listAll();
    this.listModalities();
    this.listContainers();
  },
  watch: {
    switchrequireBiradsReport: function() {
      switch (this.switchrequireBiradsReport) {
        case false:
          this.dataModal.requireBiradsReport = 0;
          break;
        case true:
          this.dataModal.requireBiradsReport = 1;
          break;
      }
    },
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError: (e) => {
      this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
    },
    showAction(action) {
      return this.action == action;
    },
    editarStatus(item) {
      this.dialog = true;
      this.dataModal = Object.assign(this.dataModal, item);
    },
    changeAction(action) {
      if (action == 1) {
        this.$refs.form.reset();
        this.dataModal = {};
        this.switchrequireBiradsReport = false;
      }
      this.action = action;
      this.checkEncabezado();
    },
    checkEncabezado() {
      switch (this.action) {
        case 1:
          this.encabezado = {
            icono: "mdi-format-list-bulleted-type",
            texto: "Perfiles de estudio",
          };
          this.dialogs = {
            title: "¿Desea cambiar el estatus de éste perfil de estudio?",
            text:
              "El perfil de estudio será habilitada / inhabilitada de inmediato y podría afectar a los registros que dependan de ella",
          };
          break;
        case 2:
          this.encabezado = {
            icono: "mdi-format-list-bulleted-type",
            texto: "Registrar perfil de estudio",
          };
          this.dialogs = {
            title: "¿Desea registrar éste perfil de estudio?",
            text:
              "El perfil de estudio será registrada de inmediato y estará disponible en el sistema",
          };
          this.iconoAdd = "mdi-plus";
          this.textoAdd = "Registrar perfil de estudio";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar registro",
            tooltip: "Cancelar registro",
            color: "error",
          };
          break;
        case 3:
          this.encabezado = {
            icono: "mdi-format-list-bulleted-type",
            texto: "Editar perfil de estudio",
          };
          this.dialogs = {
            title: "¿Desea modificar éste perfil de estudio?",
            text:
              "El perfil de estudio será modificada de inmediato y podría afectar a los registros que dependan de ella",
          };
          this.iconoAdd = "mdi-reload";
          this.textoAdd = "Editar perfil de estudio";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar Modificación",
            tooltip: "Cancelar Modificación",
            color: "error",
          };
          break;
        default:
          this.encabezado = {
            icono: "mdi-format-list-bulleted-type",
            texto: "Perfiles de estudio",
          };
          break;
      }
    },
    doAction() {
      if (this.$refs.form.validate()) {
        // this.dialog = true;
        if (this.action == 2) {
          this.add();
        } else if (this.action == 3) {
          this.update();
        }
      }
    },
    sendData() {
      this.sending = !this.sending;
    },
    checkSpeciality(e) {
      let data = {
        idModality: e,
        speciality: {
          idSpeciality: 3,
        },
      };
      ModaltyRequest.checkSpecialityByModality(data).then((res) => {
        if (res.data.data) {
          this.flagContainer = true;
        } else {
          this.flagContainer = false;
        }
      });
    },
    listModalities() {
      ModaltyRequest.allModality().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.listModality = res.data.data.map((modality) => {
            return {
              value: modality.idModality,
              text: modality.acronym + " " + modality.name,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listContainers() {
      EnumRequest.listAllContainerType().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.listContainerType = res.data.data.map((container) => {
            return {
              value: container.value,
              text: container.text,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listAll() {
      StudyModalityRequest.allStudyModality().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.list = res.data.data.map((studyModality) => {
            return {
              idStudyModality: studyModality.idStudyModality,
              name: studyModality.name,
              acronym: studyModality.acronym,
              acronymText:
                studyModality.acronym != null ? studyModality.acronym : " ---",
              modality: studyModality.modality || "--- Sin información ---",
              containerType: studyModality.containerType,
              requireBiradsReport: studyModality.requireBiradsReport,
              
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    add() {
      if (!this.sending) {
        let container;
        if (this.flagContainer) {
          container = this.dataModal.containerType;
        } else {
          container = 0;
        }
        this.sending = true;
        let postData = {
          name: this.dataModal.name.trim(),
          acronym: this.dataModal.acronym.trim(),
          modality: {
            idModality: this.dataModal.modality,
          },
          acronym: this.dataModal.acronym.trim(),
          containerType: container,
          requireBiradsReport: this.dataModal.requireBiradsReport
        };
        StudyModalityRequest.addStudyModality(postData)
          .then((res) => {
            this.listAll();
            if (res.data.response === true) {
              this.changeAction(1);
              this.$utilFront.notifications(
                "Perfil de estudio registrado correctamente",
                "SUCCESS"
              );
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              let msg =
                res.data.message ||
                "Sucedio un error al registrar el perfil de estudio";
              this.$utilFront.notifications(msg, "ERROR");
            }
          })
          .finally(() => {
            this.sending = false;
            this.flagContainer = false;
          });
      }
    },
    update() {
      if (!this.sending) {
        let container;
        if (this.flagContainer) {
          container = this.dataModal.containerType;
        } else {
          container = 0;
        }
        this.sending = true;
        let postData = {
          idStudyModality: this.dataModal.idStudyModality,
          name: this.dataModal.name.trim(),
          acronym: this.dataModal.acronym.trim(),
          modality: {
            idModality: this.dataModal.modality.idModality,
          },
          acronym: this.dataModal.acronym.trim(),
          containerType: container,
          requireBiradsReport: this.dataModal.requireBiradsReport,
        };
        StudyModalityRequest.updateStudyModality(postData)
          .then((res) => {
            this.listAll();
            if (res.data.response === true) {
              this.$utilFront.notifications(
                "Perfil de estudio modificado correctamente",
                "SUCCESS"
              );
              this.changeAction(1);
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(res.data.message, "ERROR");
            }
          })
          .finally(() => {
            this.sending = false;
            this.flagContainer = false;
          });
      }
    },
    changeStatus() {
      let post = {
        idStudyModality: this.dataModal.idStudyModality,
      };
      StudyModalityRequest.statusStudyModality(post).then((res) => {
        if (res.data.data) {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.list.forEach((element) => {
              if (element.idStudyModality == this.dataModal.idStudyModality) {
                element.status = this.dataModal.status == 0 ? 1 : 0;
              }
            });
            this.$utilFront.notifications(
              "Estatus del perfil de estudio modificado correctamente",
              "SUCCESS"
            );
            this.changeAction(1);
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.$utilFront.notifications(
              "Sucedio un error al modificar el estatus de el perfil de estudio",
              "ERROR"
            );
          }
        }
        this.sending = false;
      });
    },
    checkStudyModality(item) {
      this.dataModal = Object.assign(this.dataModal, item);
      this.checkSpeciality(this.dataModal.modality.idModality);
      switch (this.dataModal.requireBiradsReport) {
        case 1:
          this.switchrequireBiradsReport = true;
          break;
        case 0:
          this.switchrequireBiradsReport = false;
          break;
      }
      this.changeAction(3);
    },
    sleep(milliseconds) {
      const date = Date.now();
      let currentDate = null;
      do {
        currentDate = Date.now();
      } while (currentDate - date < milliseconds);
    },
    askFileImport() {
      this.importDialog = !this.importDialog;
    },
    exportStudyModality() {
      this.sending = true;
      ReportPDFRequest.exportTempleteModalityStudy()
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Perfiles de estudio.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.sending = false;
        });
    },
    importStudyModality() {
      this.importDialog = !this.importDialog;

      if (this.fileXls) {
        this.sending = true;

        let formData = new FormData();

        formData.append("file", this.fileXls);

        ReportPDFRequest.importTempleteModalityStudy(formData)
          .then((res) => {
            res.data.text().then((texto) => {
              const { done, errors, news, updates } = JSON.parse(texto).data;

              this.results = JSON.parse(texto).data;

              if (done) {
                this.fileXls = null;
                this.listAll();
              }
              this.updateModal = true;
            });
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    openDialogDelete(item) {
      this.model = Object.assign(this.model, item);
      this.dialogDelete = true;
    },
    closeDialogDelete() {
      this.model = Object.assign(this.model, {});
      this.dialogDelete = false;
    },
    deleteStudyModality() {
      this.sending = true;
      let params = { idStudyModality: this.model.idStudyModality };

      StudyModalityRequest.deleteStudyModality(params)
        .then((res) => {
          let { data, code, status } = res.data;

          if (code == 200 && data == true) {
            this.closeDialogDelete();
            this.listAll();
            this.$utilFront.notifications(
              "Perfil de estudio eliminado.",
              "SUCCESS"
            );
          } else {
            this.$utilFront.notifications(
              data || "Error al realizar la acción.",
              "ERROR"
            );
          }
        })
        .catch(this.$utilFront.errorhttp)
        .finally(() => {
          this.sending = false;
        });
    },
  },
};
</script>
